import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import PageHeading from '../PageHeading';

const styles = {
  contentHolder: {
    paddingTop: 40,
    paddingBottom: 40,
  },
}

const MainContentHolder = ({children, title, subtitle}) => (
  <div>
    <PageHeading title={title} subtitle={subtitle} />
    <Paper className="ContentSpacing" style={styles.contentHolder}>{children}</Paper>
  </div>
)

MainContentHolder.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.any,
}

export default MainContentHolder;



// WEBPACK FOOTER //
// ./src/components/MainContentHolder/index.jsx